import React, { FC } from 'react'
import styled from 'styled-components'
import { StoreSelfIntroduction_SelfIntroductionFragment } from 'generated/graphql'
import {
  exportDocx,
  exportPdf,
  exportTxt,
} from '@app.feature/coverletter/coverletter.write/screen/Toolbar/ExportButton/ExportList.module'
import useDropdown from '@app.modules/hooks/useDropdown'
import Export from 'svgIcons/Export'

type Tprops = {
  data: StoreSelfIntroduction_SelfIntroductionFragment
}

const ExportButtonMobile: FC<Tprops> = ({ data }) => {
  const [menuRef, isDropdownOpened, toggleDropdown] = useDropdown()

  return (
    <StyledWrapper ref={menuRef}>
      <Export onClick={toggleDropdown} />
      {isDropdownOpened && (
        <div className="export-list">
          <div className="export-item" onClick={() => exportDocx(data)}>
            워드(docx) 파일로 저장
          </div>
          <div className="export-item" onClick={() => exportPdf(data)}>
            PDF 파일로 저장
          </div>
          <div className="export-item" onClick={() => exportTxt(data)}>
            텍스트(txt) 파일로 저장
          </div>
        </div>
      )}
    </StyledWrapper>
  )
}

export default ExportButtonMobile

const StyledWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  .export-list {
    padding: 15px 0;
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    border: 1px solid #ddd;
    box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    padding: 10px 0px;
    white-space: nowrap;
    font-size: 12px;
    background-color: #fff;
    .export-item {
      font-size: 12px;
      padding: 7px 14px;
      :active {
        color: #01a0ff;
        background-color: #f4f4f4;
      }
    }
  }
`
